import { render, staticRenderFns } from "./CertificateFormGlobal.vue?vue&type=template&id=2db0291e&scoped=true&"
import script from "./CertificateFormGlobal.vue?vue&type=script&lang=js&"
export * from "./CertificateFormGlobal.vue?vue&type=script&lang=js&"
import style0 from "./CertificateFormGlobal.vue?vue&type=style&index=0&id=2db0291e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db0291e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db0291e')) {
      api.createRecord('2db0291e', component.options)
    } else {
      api.reload('2db0291e', component.options)
    }
    module.hot.accept("./CertificateFormGlobal.vue?vue&type=template&id=2db0291e&scoped=true&", function () {
      api.rerender('2db0291e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/CertificateFormGlobal.vue"
export default component.exports